import { useEffect, useRef } from "react";

import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";
import { Autoscroll } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";

import { useAutoScrollState } from "@/hooks/useAutoScrollState/useAutoScrollState";
import { useCall } from "@/hooks/useCall/useCall";
import { useTrack } from "@/hooks/useTrack/useTrack";

export function FloatingButton() {
  const { track } = useTrack();
  const { t } = useTranslation();
  const { activate, autoScrollEnabled } = useAutoScrollState();

  const hasScrolled = useRef(false);

  const { call } = useCall();

  const handleOnClick = () => {
    track("transcript_autoscroll_resumed", {
      call_id: call?.id,
      call_uuid: call?.uuid,
    });
    activate();
  };

  useEffect(() => {
    // Dirty patch to avoid rendering the button for the first time, although the auto scroll is disabled.
    if (autoScrollEnabled) {
      hasScrolled.current = true;
    }
  }, [autoScrollEnabled]);

  if (autoScrollEnabled || !hasScrolled.current) {
    return null;
  }

  return (
    <div data-test="go-to-top-button" className="absolute right-6 z-[1]">
      <Tooltip>
        <TooltipTrigger
          render={
            <Button
              variant="secondary"
              size="icon-lg"
              onClick={handleOnClick}
              aria-label={t("resume_autoscroll")}
            />
          }
        >
          {/* No size class: the DS icon-lg token sizes the glyph. */}
          <Autoscroll />
        </TooltipTrigger>
        <TooltipContent side="top" align="end">
          {t("resume_autoscroll")}
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
